export enum Environments {
	Development = 'development',
	Test = 'test',
	RC = 'rc',
	Production = 'production',
}
